import $ from 'jquery'

function ajaxPost(url, postData, success, error) {
    $.ajax({
        url: url,
        dataType: 'json',
        timeout: 60000,
        type: 'POST',
        xhrFields: {
            withCredentials: true
        },
        contentType: 'application/json',
        data: JSON.stringify(postData),
        success: (data) => {
            switch (data.response) {
                case 'success':
                    success(data)
                    break;
                case 'failed':
                    console.log(data)
                    error(data)
                    break;
            }
        },
        error: (xhr, status, err) => {
            console.log('fromAjax' + err + ':' + xhr.status)
            let errorCommonJson = {
                "response": "Error",
                "code": xhr.status,
                "message": 'エラーにより処理が中断されました' + xhr.responseText
            }
            error(errorCommonJson)
        }
    });
}

function ajaxGet(url, success, error) {
    $.ajax({
        url: url,
        dataType: 'json',
        timeout: 60000,
        xhrFields: {
            withCredentials: true
        },
        success: (data) => {
            switch (data.response) {
                case 'success':
                    success(data)
                    break;
                case 'failed':
                    error(data)
                    break;
            }
        },
        error: (xhr, status, err) => {
            let errorCommonJson = {
                "response": "Error",
                "code": xhr.status,
                "message": 'エラーにより処理が中断されました' + xhr.responseText
            }
            error(errorCommonJson)
        }
    });
}

export {ajaxPost}
export {ajaxGet}



// WEBPACK FOOTER //
// ./src/jsx/common/components/ajax.jsx